import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { Button } from "shared/ui/buttons/Button"
import { Skeleton } from "shared/ui/skeleton/Skeleton"

export interface ProductConfiguratorSummaryCardHeaderProps {
  image?: React.ReactNode
  onZoomImage?: () => void
  shortTitle?: string | null
  title?: string | null
  isLoading?: boolean
  isUpdating?: boolean
}

export const ProductConfiguratorSummaryCardHeader = React.memo(
  ({
    image,
    onZoomImage,
    shortTitle,
    title,
    isLoading,
    isUpdating
  }: ProductConfiguratorSummaryCardHeaderProps) => {
    const { t } = useTranslation()

    return (
      <div
        className={classNames("product-configurator-summary-card__header", {
          "product-configurator-summary-card__header--updating": isUpdating
        })}
        // The header still shows the previous (stale) title while refetching, so it's
        // hidden from assistive tech rather than read as current data.
        inert={isUpdating}
      >
        <div className="product-configurator-summary-card__image">
          {onZoomImage ? (
            <Button
              className="product-configurator-summary-card__zoom-button"
              style={{ cursor: "zoom-in" }}
              onClick={onZoomImage}
              label={t("Product.ZoomImage")}
            >
              {image}
            </Button>
          ) : (
            image
          )}
        </div>
        <div className="product-configurator-summary-card__titles">
          {isLoading ? (
            <Skeleton count={2} />
          ) : (
            <>
              <div className="product-configurator-summary-card__short-title">
                {shortTitle}
              </div>
              <div className="product-configurator-summary-card__title">
                {title}
              </div>
            </>
          )}
        </div>
      </div>
    )
  }
)
